var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"small":"","depressed":"","fab":"","color":"secondary darken-1"}},on),[_c('v-badge',{attrs:{"color":"transparent"}},[_c('v-icon',{attrs:{"size":"20","color":"white"}},[_vm._v("fa-user")])],1)],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }